/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enums_Beweegthema_Hardlopencoopertest3Inputs */

const nl_enums_beweegthema_hardlopencoopertest3 = /** @type {(inputs: Enums_Beweegthema_Hardlopencoopertest3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hardlopen (Coopertest)`)
};

/**

* @param {Enums_Beweegthema_Hardlopencoopertest3Inputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const enums_beweegthema_hardlopencoopertest3 = /** @type {((inputs?: Enums_Beweegthema_Hardlopencoopertest3Inputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enums_Beweegthema_Hardlopencoopertest3Inputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_enums_beweegthema_hardlopencoopertest3(inputs)
});
export { enums_beweegthema_hardlopencoopertest3 as "enums.Beweegthema.HardlopenCoopertest" }